export default {
    employment_status_1: 'Pre-employment quarantine',
    employment_status_2: 'Employment',
    employment_status_10000: 'All',
};
